import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BaseSecurityFilter } from './state-filter';

/**
 * simple builder for state filters chain
 */
export class StateFilterChain {

    rootFilter: BaseSecurityFilter;
    lastFilter: BaseSecurityFilter;

    /**
     * register state filter
     * @param filter {BaseSecurityFilter}
     */
    registerFilter(filter: BaseSecurityFilter): StateFilterChain {
        if (this.rootFilter) {
            this.lastFilter.setNextFilter(filter);
            this.lastFilter = filter;
        } else {
            this.rootFilter = filter;
            this.lastFilter = this.rootFilter;
        }

        return this;
    }

    /**
     * execute state chain
     * @param route {ActivatedRouteSnapshot}
     * @param state {RouterStateSnapshot}
     */
    executeChain(route: ActivatedRouteSnapshot,
                 state: RouterStateSnapshot): boolean {
        return this.rootFilter.filter(route, state);
    }

}
